/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface MCPTokenRequest
 */
export interface MCPTokenRequest {
  /**
   * Lifetime of the issued token in days. Defaults to 90, capped at 365.
   * @type {number}
   * @memberof MCPTokenRequest
   */
  lifetimeDays?: number;
  /**
   * Optional human-readable label embedded as a `name` claim and stored alongside the security-log entry. Useful for tracking which client or laptop a token belongs to.
   * @type {string}
   * @memberof MCPTokenRequest
   */
  name?: string;
}

/**
 * Check if a given object implements the MCPTokenRequest interface.
 */
export function instanceOfMCPTokenRequest(value: object): value is MCPTokenRequest {
  return true;
}

export function MCPTokenRequestFromJSON(json: any): MCPTokenRequest {
  return MCPTokenRequestFromJSONTyped(json, false);
}

export function MCPTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MCPTokenRequest {
  if (json == null) {
    return json;
  }
  return {
    lifetimeDays: json['lifetime_days'] == null ? undefined : json['lifetime_days'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function MCPTokenRequestToJSON(value?: MCPTokenRequest | null): any {
  if (value == null) {
    return value;
  }
  return {
    lifetime_days: value['lifetimeDays'],
    name: value['name'],
  };
}
